// ABOUTME: Binds the workflow label resolvers to the current intl and a workflow definition.
// ABOUTME: Returns memoized stateLabel/transitionLabel callbacks for components rendering workflow states.

import { useCallback } from 'react';
import { useIntl } from 'react-intl';

import type { WorkflowDefinition } from '../api/workflowApi';
import { resolveWorkflowStateLabel, resolveWorkflowTransitionLabel } from '../utils/workflowLabels';

export function useWorkflowLabels(workflow: WorkflowDefinition | null | undefined) {
    const intl = useIntl();
    const stateLabel = useCallback(
        (code: string) => resolveWorkflowStateLabel(intl, workflow, code),
        [intl, workflow],
    );
    const transitionLabel = useCallback(
        (from: string, to: string, event?: string) =>
            resolveWorkflowTransitionLabel(intl, workflow, from, to, event),
        [intl, workflow],
    );
    return { stateLabel, transitionLabel };
}
